import gql from "graphql-tag";

export const MY_HR_GET_STREET_TYPES = gql`
  query streetTypes {
    streetTypes {
      code
      name
    }
  }
`;
